export const DISABLE_SAVE = 'DISABLE_SAVE';
export const ENABLE_SAVE = 'ENABLE_SAVE';
export const SET_KEYWORDS_INCLUDE = 'SET_KEYWORDS_INCLUDE';
export const SET_KEYWORDS_EXCLUDE = 'SET_KEYWORDS_EXCLUDE';
export const SET_LANDING_PAGE_SNIPPET = 'SET_LANDING_PAGE_SNIPPET';
export const SET_HEADER_LINKS = 'SET_HEADER_LINKS';
